export function getBlockExplorersBaseLink(network) {
    if (!network || network === 1) {
        return 'https://etherscan.io';
    }
    else if (network === 4)
        return 'https://rinkeby.etherscan.io';
    else if (network === 137)
        return 'https://polygonscan.com';
    else if (network === 80001)
        return 'https://mumbai.polygonscan.com';
    else
        throw new Error("Network ".concat(network, " is not supported"));
}
export function getBlockExplorerTxLink(network, txnHash) {
    return "".concat(getBlockExplorersBaseLink(network), "/tx/").concat(txnHash);
}
export function getBlockExplorerAddressLink(network, address) {
    return "".concat(getBlockExplorersBaseLink(network), "/address/").concat(address);
}
//# sourceMappingURL=blockExplorerLinks.js.map